import React from 'react';
import { Spinner } from 'react-bootstrap';
import DataTable from '../../DataTable/datatable.component';
import { Nav } from 'react-bootstrap';
import CommonConfigPage from './CommonConfigPage';
import { useGetProductionLines } from '../../../hooks/useProductionLines';
import ProductionLineEditDialog from './Dialogs/ProductionLineEditDialog';
import SelectFilter from '../../DataTable/datatable.selectfilter';

function ProductionLinesTable({ onRowClick, refresh }) {

    const { productionLines, loading } = useGetProductionLines(refresh);

    const tableColumns = [
        {
            Header: 'Name',
            accessor: 'name',
            filter: 'fuzzyText',
            Cell: (props) => {
                return <Nav><Nav.Link onClick={() => { onRowClick(props.row.original); }}>{props.value}</Nav.Link></Nav>
            }
        },
        {
            Header: 'Business Unit',
            accessor: 'businessUnitName',
            Filter: SelectFilter,
            filter: 'equals'
        },
        {
            Header: 'Display',
            accessor: 'display',
            filter: 'fuzzyText'
        },
        {
            Header: 'Translation Key',
            accessor: 'translationKey',
            filter: 'fuzzyText'
        }
    ];

    if (loading) {
        return (
            <div className="d-flex justify-content-center">
                <Spinner animation="border" />
            </div>
        );
    }

    return <DataTable id="Production Lines" tableColumns={tableColumns} tableData={productionLines} />
}

function ProductionLinesConfiguration() {
    const getNewProductionLine = () => {
        return { id: null, name: "", businessUnitId: null }
    };

    return (
        <CommonConfigPage
            title="Production Lines"
            table={(showEditDialog, refreshList) => <ProductionLinesTable onRowClick={showEditDialog} refresh={refreshList} />}
            dialog={(dialogData, setDialogData, showDialog, closeDialog) => <ProductionLineEditDialog dialogData={dialogData} setDialogData={setDialogData} showDialog={showDialog} closeDialog={closeDialog} />}
            getNewConfigObject={getNewProductionLine}
        />
    );
}

export default ProductionLinesConfiguration;